'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _dekuPackery = require('@viskan/deku-packery');

var _dekuPackery2 = _interopRequireDefault(_dekuPackery);

var _actions = require('../actions');

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var CMS_DYNAMIC_GRID = 'CMS-DynamicGrid';

var repeatedlyRefreshPackery = function repeatedlyRefreshPackery(instance) {
	var startTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
	return window.requestAnimationFrame(function () {
		if (document.body.contains(instance.element)) {
			var secondsSinceStart = (new Date().getTime() - startTime.getTime()) / 1000;

			instance.reloadItems();
			instance.layout();

			if (secondsSinceStart < 30) {
				var nextRepaint = secondsSinceStart < 10 ? 500 : 1000;
				setTimeout(function () {
					return repeatedlyRefreshPackery(instance, startTime);
				}, nextRepaint);
			}
		}
	});
};

var getStyles = function getStyles(x, breakpoint, gutter) {
	var styles = {};
	var sm = x.attributes.size === 'full' ? x.attributes.size : x.attributes.size.substring(0, 1);
	var md = x.attributes['md-size'] === 'full' ? x.attributes['md-size'] : x.attributes['md-size'].substring(0, 1);
	var lg = x.attributes['lg-size'] === 'full' ? x.attributes['lg-size'] : x.attributes['lg-size'].substring(0, 1);

	switch (breakpoint) {
		case 'xsm':
			styles.width = (0, _actions.calculateCellWidth)(gutter, sm);
			break;
		case 'sm':
			styles.width = (0, _actions.calculateCellWidth)(gutter, sm);
			break;
		case 'md':
			styles.width = (0, _actions.calculateCellWidth)(gutter, md);
			break;
		case 'lg':
			styles.width = (0, _actions.calculateCellWidth)(gutter, lg);
			break;
		case 'xlg':
			styles.width = (0, _actions.calculateCellWidth)(gutter, lg);
			break;
		default:
			styles.width = (0, _actions.calculateCellWidth)(0, 1);
	}

	return styles;
};

var getItems = function getItems(_ref, breakpoint, gutter, styles) {
	var children = _ref.children,
	    dynamicWidth = _ref.dynamicWidth;

	if (dynamicWidth) {
		return children.map(function (x) {
			var style = x.attributes.componentName === 'Dynamic Cell' ? getStyles(x, breakpoint, gutter) : {};

			return (0, _magicVirtualElement2.default)(
				'div',
				{ key: x.id, style: style },
				x
			);
		});
	}

	return children.map(function (x) {
		return (0, _magicVirtualElement2.default)(
			'div',
			{ key: x.id, style: styles },
			x
		);
	});
};

var afterRender = function afterRender(_ref2, el) {
	var props = _ref2.props;

	var instance = _dekuPackery2.default.Packery.data(el.querySelector('.' + CMS_DYNAMIC_GRID));

	if (!instance || props.children.length === 0) {
		return;
	}

	instance.reloadItems();
	instance.layout();
};

var render = function render(_ref3) {
	var props = _ref3.props;
	var xsm = props.xsm,
	    sm = props.sm,
	    md = props.md,
	    lg = props.lg,
	    xlg = props.xlg;

	var breakpoint = props.breakpoint.breakpointOverride || props.breakpoint.breakpoint;
	var gutter = props.gutter.length > 3 ? parseInt(props.gutter.slice(0, 2), 10) : parseInt(props.gutter.slice(0, 1), 10);
	var styles = {};

	switch (breakpoint) {
		case 'xsm':
			styles.width = (0, _actions.calculateBreakPointWidth)(gutter, xsm);
			break;
		case 'sm':
			styles.width = (0, _actions.calculateBreakPointWidth)(gutter, sm);
			break;
		case 'md':
			styles.width = (0, _actions.calculateBreakPointWidth)(gutter, md);
			break;
		case 'lg':
			styles.width = (0, _actions.calculateBreakPointWidth)(gutter, lg);
			break;
		case 'xlg':
			styles.width = (0, _actions.calculateBreakPointWidth)(gutter, xlg);
			break;
		default:
			styles.width = (0, _actions.calculateBreakPointWidth)(0, 1);
	}

	var opts = {
		gutter: gutter,
		transitionDuration: (0, _actions.parseNumber)(props.transitionDuration, 0)
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': props.class },
		(0, _magicVirtualElement2.default)(
			_dekuPackery2.default,
			{ 'class': CMS_DYNAMIC_GRID, options: opts, instance: repeatedlyRefreshPackery },
			getItems(props, breakpoint, gutter, styles)
		)
	), props);
};

exports.default = { afterRender: afterRender, render: render };